import { LogLevel as SignalRLogLevel } from '@microsoft/signalr';
import { InjectionToken } from '../../injection';

export { SignalRLogLevel };

export const PULSE_NOTIFICATIONS_LOG_LEVEL: InjectionToken<SignalRLogLevel>
  = new InjectionToken<SignalRLogLevel>('PULSE_NOTIFICATIONS_LOG_LEVEL');
